import { createFeature, createReducer, on } from '@ngrx/store';
import { BuyerSettingsState } from './buyer-state.model';
import { BuyerActions } from './buyer.actions';

const initialState: BuyerSettingsState = {
  buyerSettings: {
    cmp: 0,
    companyName: '',
    isDecipher: false,
    isHashing: false,
    isOutboundHash: false,
    isDecipherHash: false,
    variableMapping: [],
    privateKey: '',
    decipherPrivateKey: '',
    hashType: null,
    consolidatedView: true,
    decipherHashKeyId: null,
  },
  billingRules: null,
  isBillingRulesLoading: false,
  decipherHashKeyIds: [],
  isLoading: false,
  isSaving: false,
  error: null,
};

export const buyerFeature = createFeature({
  name: 'buyer',
  reducer: createReducer(
    initialState,

    on(BuyerActions.loadBuyerSettings, (state) => ({
      ...state,
      isLoading: true,
      error: null,
    })),

    on(BuyerActions.loadBuyerSettingsSuccess, (state, { buyer }) => ({
      ...state,
      buyerSettings: buyer,
      isLoading: false,
    })),

    on(BuyerActions.loadBuyerSettingsFailure, (state, { error }) => ({
      ...state,
      isLoading: false,
      error,
    })),

    on(BuyerActions.saveBuyerSettings, (state, { update }) => ({
      ...state,
      isSaving: true,
      error: null,
      buyerSettings: { ...state.buyerSettings, ...update },
    })),

    on(BuyerActions.saveBuyerSettingsSuccess, (state) => ({
      ...state,
      isSaving: false,
    })),

    on(BuyerActions.saveBuyerSettingsFailure, (state, { error }) => ({
      ...state,
      isSaving: false,
      error,
    })),

    on(BuyerActions.loadDecipherHashKeyIdsSuccess, (state, { keyIds }) => ({
      ...state,
      decipherHashKeyIds: keyIds,
    })),

    on(BuyerActions.loadBillingRules, (state) => ({
      ...state,
      isBillingRulesLoading: true,
      error: null,
    })),

    on(BuyerActions.loadBillingRulesSuccess, (state, { billingRules }) => ({
      ...state,
      billingRules,
      isBillingRulesLoading: false,
      error: null,
    })),

    on(BuyerActions.loadBillingRulesFailure, (state) => ({
      ...state,
      isBillingRulesLoading: false,
      error: null,
    })),

    on(
      BuyerActions.createBillingRules,
      BuyerActions.updateBillingRules,
      (state) => ({
        ...state,
        isSaving: true,
        error: null,
      }),
    ),

    on(
      BuyerActions.createBillingRulesSuccess,
      BuyerActions.updateBillingRulesSuccess,
      (state, { billingRules }) => ({
        ...state,
        billingRules,
        isSaving: false,
        isLoading: false,
      }),
    ),

    on(
      BuyerActions.createBillingRulesFailure,
      BuyerActions.updateBillingRulesFailure,
      (state, { error }) => ({
        ...state,
        isSaving: false,
        error,
        isLoading: false,
      }),
    ),
  ),
});
